import { type IToastShow } from 'shared/ui'

export const CANCELED_SUBSCRIPTION_TOAST: IToastShow = {
  type: 'error',
  title:
    'Cannot add paid items to a cancelled account. Restore your subscription to add user seats, phone numbers, and other premium features.',
}
